/**
 * Action for Fetch Journey List
 */
export enum fetchJourneyList {
  FETCH_JOURNEY_LIST_REQUEST = 'FETCH_JOURNEY_LIST_REQUEST'
}
